import React, { useEffect, useState } from "react";
import { 
  BarChart, Bar, Cell, Line, ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  Pie, PieChart, Label
} from 'recharts';
import { isMobile } from "react-device-detect";

const UtilityPieChart = props => {
    const [dataModel, setDataModel] = useState([]);

    useEffect(() => {
        if(!props.totalObject) return;

        setDataModel([
              {
                "name": "Water",
                "value": props.totalObject.water,
                "color": "rgb(8,114,182)"
            },
            {
                "name": "Electricity",
                "value": props.totalObject.electricity,
                "color": "rgb(213,43,0)"
            },
            {
                "name": "Gas",
                "value": props.totalObject.gas,
                "color": "rgb(0,177,168)"

            }
        ])
    }, [props.totalObject]);

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const RADIAN = Math.PI / 180;

        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
    
        return(
            <g>
                {percent >= 0.2 && <text x={x + 10} y={y-8} fill="white" textAnchor='middle' dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
                </text>}
            </g>
        );
    };

    const formatReadings = (reading, name) => {
        let rawPct = reading / props.totalObject.total;
        
        return `${(Math.round(rawPct * 1000) / 10).toFixed(1)}%`;
    }

    return (
        <ResponsiveContainer height={isMobile ? 300 : '85%'} width='100%'>
            <PieChart width={props.pageWidth/2} height={props.pageWidth/2} style={{margin:'auto'}}>
                <Pie
                    data={dataModel}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={isMobile ? false : renderCustomizedLabel}
                    outerRadius={props.pageWidth/6}
                    fill="#8884d8"
                    dataKey="value"
                >
                    {dataModel?.map((data, i) => (
                        <Cell key={`cell-${i}`} fill={data.color} />
                    ))}
                    <Label position='outside'/>
                </Pie>

                <Tooltip 
                    contentStyle={{
                        backgroundColor: '#F5F5F5',
                        color: '#333',
                        border:'1px solid lightgrey',
                        fontSize: isMobile ? "0.7em" : '0.75em',
                    }}
                    wrapperStyle={{ outline: "none" }}
                    formatter={formatReadings}
                />

                <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{fontSize: isMobile ? "0.7rem" : "0.85rem"}}/>
            </PieChart>
        </ResponsiveContainer>
    );
}

export default UtilityPieChart;